import React, { useState, useEffect, useRef } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje, MensajeSiNo } from "../mensajes";
import axios from "axios";
import { Toasts } from "../toasts";
import { ActualizarInmuebles } from "./modalActualizarInmuebles";

const TablaInmuebles = () => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accopinm = JSON.parse(localStorage.getItem("accopinm"));

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          CÓDIGO
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Descripción",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-signature">
          {" "}
          DESCRIPCIÓN
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Dirección",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-map-marker-alt">
          {" "}
          DIRECCIÓN
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [inmueble, setInmueble] = useState();
  const [estado, setEstado] = useState();
  const [municipio, setMunicipio] = useState();
  const [ciudad, setCiudad] = useState();
  const [operacion, setOperacion] = useState(1);
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idinmuebles.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.direccion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarRegistros = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "inmuebles";
    let orden = "idinmuebles";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          txtBuscador.current.focus();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarRegistro = (id) => {
    setActivate(true);

    let campos =
      "idinmuebles, trim(descripcion) AS descripcion, estado, municipio, ciudad, trim(direccion) AS direccion";
    let nomtab = "inmuebles";
    let nomid = "idinmuebles";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idinmuebles > 0) {
            setInmueble(response.data);
            seleccionarEstado(response.data);
          } else {
            setInmueble();
            seleccionarEstado(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarEstado = (data) => {
    setActivate(true);

    let campos = "idestado, trim(nombre)  AS nombre";
    let nomtab = "estado";
    let nomid = "idestado";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.estado}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setEstado(response.data);
            SeleccionarMunicipio(data);
          } else {
            setEstado();
            SeleccionarMunicipio(data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SeleccionarMunicipio = (data) => {
    let campos = "idmunicipio, trim(nombre)  AS nombre";
    let nomtab = "municipio";
    let nomid = "idestado";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${data.estado}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setMunicipio(response.data);
            SeleccionarCiudad(data);
          } else {
            setMunicipio();
            SeleccionarCiudad(data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SeleccionarCiudad = (data) => {
    let campos = "idciudad, trim(nombre)  AS nombre";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${data.municipio}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setCiudad(response.data);
            setMostrar2(true);
          } else {
            setCiudad();
            setMostrar2(true);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const gestionarExpendedor = (op, id) => (e) => {
    if (op === 4) {
      if (accopinm.substring(0, 1) !== "0") {
        setOperacion(4);
        SeleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accopinm.substring(1, 2) !== "0") {
        setOperacion(op);
        setMostrar2(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accopinm.substring(2, 3) !== "0") {
        setOperacion(op);
        SeleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accopinm.substring(3, 4) !== "0") {
        setOperacion(op);
        SeleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  const handleCloseSi = () => {
    setActivate(false);
    SeleccionarRegistro();
    setMostrar4(false);
  };

  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  return (
    <div
      className="p-0 m-0"
      style={{ backgroundColor: "#", height: "100%", width: "100%" }}
    >
      <div className="row col-md-10 py-5 mx-auto">
        <div className="col-md-12 p-2 mt-4">
          <div className="row col-md-12 d-flex justify-content-between">
            <input
              type="text"
              className="col-2 form-control form-control-sm rounded-pill"
              ref={txtBuscador}
              onChange={handleSearch}
              placeholder="Buscar"
            />
            <div className="col-2 d-flex justify-content-end">
              <button
                onClick={gestionarExpendedor(1, "")}
                className={
                  accopinm.substring(1, 2) === "0"
                    ? "btn btn-sm btn-secondary rounded-circle"
                    : "btn btn-sm btn-primary rounded-circle"
                }
              >
                <i className="fas fa-plus"></i>{" "}
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow key={index} style={{ padding: "0" }}>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.idinmuebles}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.descripcion}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.direccion}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      <button
                        onClick={gestionarExpendedor(4, item.idinmuebles)}
                        className={
                          accopinm.substring(0, 1) === "0"
                            ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                            : "btn btn-sm  btn-info rounded-circle ml-2"
                        }
                      >
                        <i className="fas fa-eye"></i>{" "}
                      </button>
                      <button
                        onClick={gestionarExpendedor(2, item.idinmuebles)}
                        className={
                          accopinm.substring(2, 3) === "0"
                            ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                            : "btn btn-sm  btn-warning rounded-circle ml-2"
                        }
                      >
                        <i className="fa fa-edit"></i>{" "}
                      </button>
                      <button
                        onClick={gestionarExpendedor(3, item.idinmuebles)}
                        className={
                          accopinm.substring(3, 4) === "0"
                            ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                            : "btn btn-sm  btn-danger rounded-circle ml-2"
                        }
                      >
                        <i className="fa fa-trash"></i>{" "}
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>

        <ActualizarInmuebles
          show={mostrar2}
          operacion={operacion}
          inmuebles={inmueble}
          estado={estado}
          municipio={municipio}
          ciudad={ciudad}
          onHideCancela={handleCancela2}
          onHideRenderizar={SeleccionarRegistros}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
      </div>
      <Dimmer active={activate} />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
};
export default TablaInmuebles;



// WEBPACK FOOTER //
// ./src/components/rentas/tablaInmuebles.js